import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=a45177b8&scoped=true&"
import script from "./Lesson.vue?vue&type=script&lang=js&"
export * from "./Lesson.vue?vue&type=script&lang=js&"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=a45177b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45177b8",
  null
  
)

export default component.exports